<template>
  <div class="form-page position-relative" :class="{'p-3': $store.state.isMobile}">
    <div v-if="loading || !isUserLoaded">
      <div class="loading-shade" :class="{'compensate': !$store.state.isMobile}"></div>
      <pre-loader></pre-loader>
    </div>

    <div>
      <div class="header">
        <div class="title">User Preferences - {{ $store.state.user.cust_Ref }}</div>
      </div>
      <hr>
    </div>

    <form @submit.prevent="submit">
      <div>

        <div class="fields-grid-3">
          <div class="field-wr">
            <div class="label">Bet odds format</div>
            <div v-for="(opt) in ENUMS.oddOptions" :key="opt.id">
              <label>
                <input class="radio geoff-radio" type="radio" :value="opt.id" v-model="userPrefModel.selectedOdd">
                <span>{{ opt.name }}</span>
              </label>
            </div>
          </div>

          <div class="field-wr">
            <div class="label">Default carousel</div>
            <div v-for="(opt) in ENUMS.homeSliderList" :key="opt.id">
              <label>
                <input class="radio geoff-radio" type="radio" :value="opt.id" v-model="userPrefModel.selectedCarousel">
                <span>{{ opt.name }}</span>
              </label>
            </div>
          </div>

          <div class="field-wr">
            <div class="label">Default Sorting</div>
            <div v-for="(opt) in ENUMS.sortOptions" :key="opt.id">
              <label>
                <input class="radio geoff-radio" type="radio" :value="opt.id" v-model="userPrefModel.selectedSorting">
                <span>{{ opt.name }}</span>
              </label>
            </div>
          </div>

          <div class="field-wr">
            <div class="label">Default Carousel Region</div>
            <div v-for="(opt) in ENUMS.carouselRegionOptions" :key="opt.id">
              <label>
                <input class="radio geoff-radio" type="radio" :value="opt.id" v-model="userPrefModel.carouselRegion">
                <span>{{ opt.name }}</span>
              </label>
            </div>
          </div>
        </div>

        <div class="field-wr">
          <div class="label">Marketing Preferences:</div>
          <div><i>I Consent to receive marketing from Geoff Banks Online for Real Sports Events via:</i></div>
          <div class="flex-list">
            <vue-checkbox 
              class="checkbox-input"
              v-model="userPrefModel.realSportsMarketing.byEmail"
              name="cbx-marketing-real-email"
              description="Email"
              label-class="w-100"
            >
              <div class="cbx-label">Email</div>
            </vue-checkbox>

            <vue-checkbox 
              class="checkbox-input"
              v-model="userPrefModel.realSportsMarketing.bySms"
              name="cbx-marketing-real-sms"
              description="SMS"
              label-class="w-100"
            >
              <div class="cbx-label">SMS</div>
            </vue-checkbox>
          </div>

          <div><i>I Consent to receive marketing from Geoff Banks Online for Virtual Sports Events via:</i></div>
          <div class="max-width-field flex-list">
            <vue-checkbox 
              class="checkbox-input"
              v-model="userPrefModel.virtualSportsMarketing.byEmail"
              name="cbx-marketing-virtual-email"
              description="Email"
              label-class="w-100"
            >
              <div class="cbx-label">Email</div>
            </vue-checkbox>

            <vue-checkbox 
              class="checkbox-input"
              v-model="userPrefModel.virtualSportsMarketing.bySms"
              name="cbx-marketing-virtual-sms"
              description="SMS"
              label-class="w-100"
            >
              <div class="cbx-label">SMS</div>
            </vue-checkbox>
          </div>
        </div>

        <div class="fields-grid-21">
          <vue-button cls="main" class="my-5">Submit</vue-button>
        </div>

      </div>
    </form>

  </div>
</template>

<script>
  import VueButton from "@/components/UI/VueButton";
  import PreLoader from "@/components/UI/PreLoader";
  import VueCheckbox from "@/components/UI/VueCheckbox";

  export default {
    name: "UserPreferencesView",
    components: {
      PreLoader, 
      VueButton,
      VueCheckbox
    },
    data:()=>{
      return {
        loading: false,
        userPrefModel: {
          selectedOdd: 1, 
          selectedCarousel: 1, 
          selectedSorting: 1,
          carouselRegion: 1,

          realSportsMarketing: {
            byEmail: null,
            bySms: null,
          },
          virtualSportsMarketing: {
            byEmail: null,
            bySms: null,
          }
        }

      }
    },
    computed: {
      isUserLoaded() {
        return (this.$store.state.user.preferences?.carousel &&
          this.$store.state.user.preferences?.oddFormat &&
          this.$store.state.user.preferences?.sortRacing &&
          this.$store.state.user.preferences?.carouselRegion&&
          this.$store.state.user.preferences?.realSportsMarketing&&
          this.$store.state.user.preferences?.virtualSportsMarketing
        )
      }
    },
    mounted() {
      const vm = this
      vm.loading = true
      if (this.isUserLoaded) {
        this.setInitValues()
        this.loading = false
      }
    },
    watch:{
      isUserLoaded(val) {
        if (val) {
          this.setInitValues()
          this.loading = false
        }
      },
      email(value, lastValue){
        if (value !== lastValue && lastValue) {
          console.log('cur - ', value, 'last - ', lastValue)
          this.emailWasChanged = true
        }
      },

    },
    methods:{
      setInitValues(){
        this.userPrefModel = {
          selectedOdd: this.$store.state.user.preferences?.oddFormat,
          selectedCarousel: this.$store.state.user.preferences?.carousel,
          selectedSorting: this.$store.state.user.preferences?.sortRacing,
          carouselRegion: this.$store.state.user.preferences?.carouselRegion,
          realSportsMarketing: this.$store.state.user.preferences?.realSportsMarketing,
          virtualSportsMarketing: this.$store.state.user.preferences?.virtualSportsMarketing
        }
      },
    
      submit(){
        const vm = this
        vm.loading = true
        const model = {
            OddFormat: this.userPrefModel.selectedOdd,
            Carousel: this.userPrefModel.selectedCarousel,
            SortRacing: this.userPrefModel.selectedSorting,
            CarouselRegion: this.userPrefModel.carouselRegion,
            RealSportsMarketing: this.userPrefModel.realSportsMarketing,
            VirtualSportsMarketing: this.userPrefModel.virtualSportsMarketing,
        }
        this.API.setUserPreferencesAzure(model)
          .then(() => {
            vm.$store.dispatch('LOGIN', JSON.parse(localStorage.getItem('userCreds')))
              .then(() => {
                vm.$toast.success("Your information has been submitted successfully.")
              })
              .finally(()=>vm.loading = false)
          })
      },
    }
  }
</script>

<style scoped lang="scss">
// TODO: move to global?
.form-page {
  .header {
    .title {
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
    }
  }
  .section {
    margin-bottom: 2rem;
    * {
      margin-bottom: 0.5rem;
    }
  }
  .subheader {
      font-weight: 700;
  }
  .question {
    font-style: italic;
  }
}

.field-wr {
  margin-bottom: 1rem;
  .label {
    font-weight: 700;
    margin-bottom: 0.5rem;
  }
  .radio {
    margin-right: 0.5rem;
  }

}

.fields-grid-3 {

  @media screen and (min-width: 640px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 2rem;
  }
}
.fields-grid-2 {

  @media screen and (min-width: 640px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
  }
}

.flex-list {
  display: flex;
  gap: 2rem;
}
</style>